import { useContext } from 'react';

import { GDPRContext } from './GDPRContext';

export const useGDPRContext = () => useContext(GDPRContext);
